let cachedSymbols = null;

export const convertMana = async (manaCostString, setStateCallback) => {
  if (!manaCostString) return;

  if (!cachedSymbols) {
    const response = await fetch('https://api.scryfall.com/symbology');
    const data = await response.json();
    cachedSymbols = data.data;
  }

  const symbols = manaCostString.match(/{[^}]+}/g); // ['{W}', '{U}']
  const rendered = symbols?.map((symbol, idx) => {
    const match = cachedSymbols.find(s => s.symbol === symbol);
    if (!match) return null;

    return (
      <img
        key={idx}
        src={match.svg_uri}
        alt={match.english}
        className="mana-symbol"
        title={match.english}
      />
    );
  });

  setStateCallback(rendered);
};
